<!--新增排班-->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <el-container>
      <el-aside style="margin-right: 20px;">
        <div style="line-height: 40px;">
          <el-input placeholder="搜索姓名" suffix-icon="el-icon-search" v-model="selName"></el-input>
        </div>
        <div style="overflow-y:auto;height:600px">
          <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            node-key="Id"
            :props="treeProps"
            :default-expanded-keys="defaultexpanded"
            :filter-node-method="filterNode"
            @check-change="checkchange"
          >
            <span slot-scope="{ node, data }">
              <span>{{ node.label }} {{data.Type=="org"?'('+data.StaffCount+')':""}}</span>
            </span>
          </el-tree>
        </div>
      </el-aside>
      <el-main>
        <el-form ref="form" :model="scheduleModel" label-width="100px">
          <el-form-item label="排班对象：" prop="StaffIds">
            <el-select
              v-model="scheduleModel.StaffIds"
              filterable
              clearable
              multiple
              remote
              :remote-method="(val)=>getStaffsSelectList(val)"
              :loading="getstaffsLoading"
              class="staffSel"
              @remove-tag="removeTag"
              @clear="clearSelected"
            >
              <el-option
                v-for="item in staffsSelectList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间：" prop="StartTime">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="scheduleModel.StartTime"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col :span="11" class="msg">(不能为空，作为按天周期循环开始日期)</el-col>
          </el-form-item>
          <el-form-item label="结束时间：" prop="EndTime">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="scheduleModel.EndTime"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col :span="11" class="msg">(为空则不限制)</el-col>
          </el-form-item>
          <el-form-item label="工作班次：" prop="SetId">
            <el-col :span="11">
              <el-select
                v-model="scheduleModel.SetId"
                filterable
                clearable
                style="width:100%;"
                @visible-change="getTimeSetSelectList($event)"
                :loading="getTimeSetLoading"
              >
                <el-option
                  v-for="item in timeSetSelectList"
                  :key="item.Id"
                  :label="item.SetName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="11" class="msg" style="color:blue;cursor: pointer;">
              <span @click="gotoWorkTimeSetManage(false)">[管理]</span>
            </el-col>
          </el-form-item>
          <el-form-item label="临时排班：" prop="IsTemp">
            <el-checkbox v-model="scheduleModel.IsTemp"></el-checkbox>
            <span class="msg">(系统优先使用临时排班)</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "addWorkTime",
  components: {
    breadcrumb
  },
  data() {
    let userMsg=this.$util.getLocalStorage("userMsg");
    return {
      entpId: userMsg.EntpId,
      staffNames: "",
      scheduleModel: {
        EntpId: userMsg.EntpId,
        SetId: "",
        StartTime: "",
        EndTime: "",
        IsTemp: false,
        StaffIds: []
      },
      timeSetSelectList: [], //工作班次列表
      getTimeSetLoading: false,
      staffsSelectList: [], //员工列表
      getstaffsLoading: false,
      selName: "",
      treeData: [], //组织树数据
      treeProps: {
        children: "Childrens",
        label: "Name"
      },
      defaultexpanded: []
    };
  },
  watch: {
    selName(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getTree();
  },
  methods: {
    gotoWorkTimeSetManage(noConfirm) {
      if (!noConfirm) {
        this.$confirm(
          "是否要离开该页面，离开后已编辑的内容将不保存！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.$router.push({
              path: "/attendanceSetting/workTimeSetManage"
            });
          })
          .catch(err => {});
      } else {
        this.$router.push({
          path: "/attendanceSetting/workTimeSetManage"
        });
      }
    },
    //获取企业班次列表
    getTimeSetSelectList(event) {
      let that = this;
      if (!event || that.timeSetSelectList.length > 0) {
        return;
      }
      that.getTimeSetLoading = true;
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetTimeSetSelectList",
          data: { entpId: that.entpId },
          hideLoading: true
        })
        .then(res => {
          that.getTimeSetLoading = false;
          if (res.data) {
            that.timeSetSelectList = res.data;
          }
        })
        .catch(err => {
          that.getTimeSetLoading = false;
        });
    },
    //获取企业员工列表
    getStaffsSelectList(val) {
      let that = this;
      if (!val) {
        return;
      }
      that.getstaffsLoading = true;
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetEntpStaffsSelectList",
          data: { entpId: that.entpId, name: val },
          hideLoading: true
        })
        .then(res => {
          that.getstaffsLoading = false;
          if (res.data) {
            that.staffsSelectList = res.data;
          }
        })
        .catch(err => {
          that.getstaffsLoading = false;
        });
    },
    getTree() {
      let that = this;
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetOrgTreeWithStaff",
          data: { entpId: this.entpId }
        })
        .then(res => {
          if (res.data) {
            if (res.data[0].Id == null) {
              res.data[0].Id = "1";
            }
            that.treeData = res.data;
            that.defaultexpanded = [res.data[0].Id];
          }
        })
        .catch(err => {});
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
    checkchange(data, checked, lchecked) {     
      if (checked) {
        let checkedNodes = this.$refs.tree.getCheckedNodes(true, false);
        for (let i = 0; i < checkedNodes.length; i++) {
          if (checkedNodes[i].Type == "staff") {
            let isexist = this.staffsSelectList.some(item => {
              if (item.Id == checkedNodes[i].Id) {
                return true;
              }
            });
            if (!isexist) {
              this.staffsSelectList.push({
                Id: checkedNodes[i].Id,
                Name: checkedNodes[i].Name
              });
            }
            let index = this.scheduleModel.StaffIds.indexOf(checkedNodes[i].Id);
            if (index == -1) {
              this.scheduleModel.StaffIds.push(checkedNodes[i].Id);
            }
          }
        }
      } else {
        let checkedKeys = this.$refs.tree.getCheckedKeys(true);
        let staffIds = this.scheduleModel.StaffIds;
        for (let i = 0; i < staffIds.length; i++) {
          if (checkedKeys.indexOf(staffIds[i]) == -1) {
            this.scheduleModel.StaffIds.splice(i, 1);
          }
        }
      }
    },
    removeTag(val) {
      this.$refs.tree.setChecked(val, false, false);
    },
    clearSelected() {
      this.$refs.tree.setCheckedKeys([]);
    },
    onSubmit() {
      let that = this;
      
      if (that.scheduleModel.StaffIds.length == 0) {
        this.$util.warningMsg("请选择排班对象！");
        return false;
      }
      if (!that.scheduleModel.StartTime) {
        this.$util.warningMsg("开始时间不能为空！");
        return false;
      }
      if (that.scheduleModel.EndTime) {
        let start = new Date(
          that.scheduleModel.StartTime.replace("-", "/").replace("-", "/")
        );
        let end = new Date(
          that.scheduleModel.EndTime.replace("-", "/").replace("-", "/")
        );
        if (end < start) {
          this.$util.warningMsg("结束时间不能小于开始时间!");
          return false;
        }
      }
      if (!that.scheduleModel.SetId) {
        this.$util.warningMsg("请选择工作班次！");
        return false;
      }

      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/EditStaffSchedule",
          data: that.scheduleModel
        })
        .then(res => {
          if (res.errcode == 0) {
            this.$confirm("新增排班成功，是否继续操作？", "提示", {
              confirmButtonText: "继续新增",
              cancelButtonText: "前往排班管理",
              type: "success",
              center: true
            })
              .then(() => {
                this.scheduleModel = {
                  EntpId: this.entpId,
                  SetId: "",
                  StartTime: "",
                  EndTime: "",
                  IsTemp: false,
                  StaffIds: []
                };
                this.$refs.tree.setCheckedKeys([]); 
              })
              .catch(() => {
                this.$router.push({
                  path: "/workTime/workTimeManage"
                });
              });
          }
        })
        .catch(err => {});
    }
  }
};
</script>    


<style lang="less" scoped>
.el-container {
  height: 650px;
  width: 1200px;
}

.el-main {
  color: #333;
  border: solid 1px #ebeef5;
}
.el-aside {
  color: #333;
  border: solid 1px #ebeef5;
  overflow: hidden;
}
.msg {
  color: red;
  padding-left: 10px;
  text-align: left;
}
.success-container {
  width: auto;
  overflow: hidden;
  .el-main {
    text-align: center;
    line-height: unset;
    border: unset;
    overflow: hidden;
    .el-link {
      width: auto;
      margin: 5px 20px;
      border-bottom: 1px solid;
    }
  }
}
</style>

<style  lang="less">
.staffSel {
  width: 100%;
  .el-select__tags {
    max-height: 300px !important;
    overflow-y: auto !important;
  }
}
</style>